import type React from 'react';

import { useTranslation } from 'react-i18next';

import { AssetsService } from '../../../../services/AssetsService';

import { StyledEmptyStateContainer, StyledIcon, StyledText } from './styles';

export const EmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledEmptyStateContainer>
      <StyledIcon src={AssetsService.assetUrl('/images/empty-state-lighthouse.svg')} />
      <StyledText>{t('company.signals.empty.text')}</StyledText>
    </StyledEmptyStateContainer>
  );
};
